<template><svg viewBox="0 0 8 13" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h2v13H0zM6 0h2v13H6z"/></svg></template>